import { render } from "./TwilioTrackingForm.vue?vue&type=template&id=63049c6c"
import script from "./TwilioTrackingForm.vue?vue&type=script&lang=js"
export * from "./TwilioTrackingForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__